import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const SubmitEmailSuccess = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/business-updates-revamp/components/SubmitEmailSuccessContent'
      )
  )
};

export default SubmitEmailSuccess;
